module.exports = __webpack_public_path__ + "r-v3/img/img_progress3.7555bce1.svg";